import { render, staticRenderFns } from "./EntityAdmin.vue?vue&type=template&id=1fae882c&"
import script from "./EntityAdmin.vue?vue&type=script&lang=js&"
export * from "./EntityAdmin.vue?vue&type=script&lang=js&"
import style0 from "./EntityAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports